import { h } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";

import { Badge, Box, Button, Grid, Paper, Stack, Tabs, Tab, TextField, Typography } from "@mui/material";

import VerificationPhoneCodeDialog from "../PopUps/VerificationPhoneCodeDialog";
import { AppContext } from "../../AppContext";

import DeleteUserDialog from "../PopUps/DeleteUserDialog";
import BackButton from "../Common/BackButton";
import Pwd from "../Common/Pwd";
import NotaryCard from "../Common/NotaryCard";
import UserDetails1 from "../Common/UserDetails1";
import UserDetails2v2 from "../Common/UserDetails2v2";

import AmbassadorDetails from "../Common/AmbassadorDetails";
import LockPersonIcon from '@mui/icons-material/LockPerson';

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`scrollable-auto-tabpanel-${index}`}
			aria-labelledby={`scrollable-auto-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={3}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

export default function User({ uid, from }) {
	console.log("render User");
	const [state, setState] = useState({ changes: false });
	const [updatedData, setUpdatedData] = useState({ uid: uid });
	const app = useContext(AppContext);

	const [stateDeleteUserDialog, setStateDeleteUserDialog] = useState({
		open: false,
	});
	const handleCloseDeleteUserDialog = () => {
		setStateDeleteUserDialog({
			...stateDeleteUserDialog,
			open: false,
		});
	};
	const [stateVerificationPhoneCodeDialog, setStateVerificationPhoneCodeDialog] = useState({
		open: false,
	});
	const handleCloseVerificationPhoneCodeDialog = () => {
		setStateVerificationPhoneCodeDialog({
			...stateVerificationPhoneCodeDialog,
			open: false,
		});
	};
	const [tab, setTab] = useState(0);
	const handleChangeTab = (event, newValue) => {
		setTab(newValue);
		if (newValue === 2 && !state.ambassador_schedule_set) {
			setUpdatedData({
				...updatedData,
				changes: true,
				seen_wk: true,
			});
		}
	};
	useEffect(() => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/c9caf42e2bfa4f439a59fbbe15877368", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setState((state) => ({
							...state,
							...res.pld,
							phone1_init: res.pld.phone1,
						}));

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);
	if (state.email === undefined) return;
	var tab_du, tab_a, tab_pwd = undefined;
	if (state.role_du) {
		tab_du = 2;
		if (state.role_a) {
			tab_a = 2;
			tab_pwd = 3;
		} else {
			tab_pwd = 2;
		}
	} else {
		if (state.role_a) {
			tab_a = 2;
			tab_pwd = 3;
		} else {
			tab_pwd = 2;
		}
	}
	const whichNext = () => {
		//console.log("whichNext", state.visible_gen, state.visible_adr, state.visible_du, state.visible_amb)

		if (!state.visible_gen) {

			setTab(0)
			return
		}

		if (!state.visible_adr) {

			setTab(1)
			return
		}

		// if (state.role_du && !state.visible_du) {

		// 	setTab(tab_du)
		// 	return
		// }

		if (state.role_a && !state.visible_amb) {

			setTab(tab_a)
			return
		}

		return 0
	}
	const whichNext2 = () => {
		//console.log("whichNext2", state.visible_gen, state.visible_adr, state.visible_du, state.visible_amb)

		if (!state.visible_gen && tab === 0) {

			if (!state.visible_adr) {

				return "Enregistrer et compléter mon adresse"
			}
			if (state.role_du && !state.visible_du) {

				return "Enregistrer"
			}
			if (state.role_a && !state.visible_amb) {

				return "Enregistrer et compléter mon profil"
			}
		}

		if (!state.visible_gen) {

			return "Enregistrer et compléter mon adresse"
		}
		if (state.visible_gen && !state.visible_adr) {

			return "Enregistrer et compléter mon adresse"
		}

		if (state.visible_adr && state.role_du) { // && !state.visible_du) {

			return "Enregistrer"
		}
		if (state.visible_adr && !state.visible_amb) {

			return "Enregistrer et compléter mon profil"
		}
		return "Enregistrer"
	}
	useEffect(() => {
		//.log(state)
		const visible_gen = (state.details_ok && state.birth_ok && state.tel_ok && state.mail_ok);
		//console.log("render because of state ", visible_gen, state.visible_gen)
		if (state.visible_gen !== visible_gen) {
			setState({ ...state, visible_gen: visible_gen })
		}
		const visible_adr = (state.addr_line1 && state.addr_zip_code && state.addr_city && state.addr_line1.length > 0 && state.addr_zip_code.length > 0 && state.addr_city.length > 0);
		//console.log("render because of state ", visible_adr, state.visible_adr)
		if (state.visible_adr !== visible_adr) {
			setState({ ...state, visible_adr: visible_adr })
		}
		const visible_amb = (state.id && (state.ambassador_organization_or_individual == 1 || (state.ambassador_organization_or_individual == 2 && state.ambassador_organization_type_id && state.ambassador_organization_name && state.ambassador_organization_id && (state.ambassador_same_address || state.ambassador_addr_line1))));
		//	const visible_amb = (state.id && state.ambassador_schedule_set);
		//console.log("render because of state ", visible_amb, state.visible_amb)
		if (state.visible_amb !== visible_amb) {
			setState({ ...state, visible_amb: visible_amb })
		}

		if (state.role_du) {


			const visible_du = !(state.notary_email === null || state.notary_fname === null || state.notary_lname === null);
			//console.log("role_du", state, visible_du)
			if (state.visible_du !== visible_du) {
				setState({ ...state, visible_du: visible_du })
			}
		}

		whichNext();

		if (state.role_a && !state.ambassador_onboarding && state.visible_gen && state.visible_adr && state.visible_amb) {
			app.refPopUp.current.handleChangeState(
				{ opened: true, type: "007" }
			)
		}
		if (state.role_du && !state.seller_onboarding && state.visible_gen && state.visible_adr) {
			app.refPopUp.current.handleChangeState(
				{ opened: true, type: "023" }
			)
		}
	}, [state]);

	const handleSubmit = () => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ role_a: state.role_a, ...updatedData }),
		};
		fetch("/api/65ea88b0ab2c41e88d4f24f8034132b5", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":

						if (state.role_a && !state.ambassador_onboarding && res.pld.ambassador_onboarding) {
							app.refPopUp.current.handleChangeState(
								{ opened: true, type: "007" }
							)
						}
						if (state.role_du && !state.seller_onboarding && res.pld.seller_onboarding) {
							app.refPopUp.current.handleChangeState(
								{ opened: true, type: "023" }
							)
						}
						setUpdatedData({
							...updatedData,
							changes: false,

						});

						setState((state) => ({
							...state,
							...res.pld,
							phone1_init: res.pld.phone1,
						}));
						app.refSnack.current.handleChangeState({ o: true, m: "Les modifications ont été validées", s: "success" });
						window.location.reload();
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	const fireSubmit = () => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ role_a: state.role_a, ...updatedData }),
		};
		fetch("/api/65ea88b0ab2c41e88d4f24f8034132b5", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":


						setUpdatedData({
							...updatedData,
							changes: false,

						});

						setState((state) => ({
							...state,
							...res.pld,
							phone1_init: res.pld.phone1,
						}));
						//app.refSnack.current.handleChangeState({ o: true, m: "Les modifications ont été validées", s: "success" });

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};

	function a11yProps(index) {
		return {
			id: `scrollable-auto-tab-${index}`,
			"aria-controls": `scrollable-auto-tabpanel-${index}`,
		};
	}
	const handleChange = (event) => {
		//console.log("handleChange user", event);
		setUpdatedData({
			...updatedData,
			changes: true,
			[event.target.name]: event.target.value,
		});
	};

	const handleChangeCheckbox = (event) => {
		setUpdatedData({
			...updatedData,
			changes: true,
			[event.target.name]: event.target.checked,
		});

	};

	return (
		<div style=" padding-top: 16px;">
			<DeleteUserDialog onClose={handleCloseDeleteUserDialog} state={stateDeleteUserDialog} />
			<VerificationPhoneCodeDialog state={stateVerificationPhoneCodeDialog} onClose={handleCloseVerificationPhoneCodeDialog} />
			<Grid container spacing={2}>
				<Grid item xs={12}>

					<Paper style={{ paddingRight: "10px", paddingLeft: "10px", paddingTop: "10px", paddingBottom: "10px" }}>
						<Box display="flex" justifyContent="space-between" alignItems="center">
							<Box>
								<BackButton tooltip={"Revenir au tableau de bord"} from={from} />

							</Box>
							<Box>
								<Typography variant="h5" >
									Vos informations personnelles
								</Typography>
							</Box>
							<Box>

								<Button
									variant="outlined"
									onClick={() => {
										setStateDeleteUserDialog({
											open: true,
										});
									}}
								>
									Me désinscrire
								</Button>
							</Box>
						</Box>
					</Paper>
				</Grid>
				<Grid item xs={12} lg={3}>
					<Paper style="padding: 10px; height: 100%; background-color: rgb(240,240,240)">
						<Typography variant="body1">
							Merci de compléter vos informations personnelles.
						</Typography>
						{/* <Typography variant="body1">
							Si vous modifiez vos informations personnelles, il se peut que cela puisse remettre en question les transactions
							auxquelles vous participez.
						</Typography> */}
					</Paper>
				</Grid>
				<Grid item xs={12} lg={9}>
					<Paper square>
						<Tabs value={tab} indicatorColor="primary" textColor="primary" onChange={handleChangeTab} aria-label="user tabs">
							<Tab
								label={
									<Badge
										color="primary"
										variant="dot"
										invisible={state.visible_gen}
									>
										Général
									</Badge>
								}
								{...a11yProps(0)}
								style="padding-right: 8px; padding-left: 8px;"
							/>
							<Tab
								label={
									<Badge color="primary" variant="dot" invisible={state.visible_adr}>
										Adresse
									</Badge>
								}
								{...a11yProps(1)}
								style="padding-right: 8px; padding-left: 8px;"
							/>
							{false && state.role_du && (
								<Tab
									label={

										"Mon notaire"
									}
									{...a11yProps(2)}
								/>
							)}
							{state.role_a && (
								<Tab
									label={
										<Badge color="primary" variant="dot" invisible={state.visible_amb}>
											Ambassadeur
										</Badge>
									}
									{...a11yProps(tab_a)}
									style="padding-right: 8px; padding-left: 8px;"
								/>
							)}
							<Tab label={<LockPersonIcon />} {...a11yProps(tab_pwd)} />
							{/* <Tab label="Sécurité" {...a11yProps(tab_pwd)} /> */}
						</Tabs>
						<TabPanel value={tab} index={0}>
							<UserDetails1 state={{ ...state, ...updatedData }} handleChange={handleChange} mode="U" />
						</TabPanel>
						<TabPanel value={tab} index={1}>
							<UserDetails2v2 state={{ ...state, ...updatedData }} handleChange={handleChange} />
						</TabPanel>
						{false && state.role_du && (
							<TabPanel value={tab} index={tab_du}>
								<NotaryCard state={{ ...state, ...updatedData }} handleChange={handleChange} />
							</TabPanel>
						)}
						{state.role_a && (
							<TabPanel value={tab} index={tab_a}>
								<AmbassadorDetails uid={uid} upperState={{ ...state, ...updatedData }} handleChange={handleChange} handleChangeCheckbox={handleChangeCheckbox} fireSubmit={fireSubmit} />
							</TabPanel>
						)}

						<TabPanel value={tab} index={tab_pwd}>
							<Pwd upperState={{ ...state, ...updatedData }} handleChange={handleChange} />
						</TabPanel>
						{tab < tab_pwd && (
							<Box display="flex" justifyContent="space-between" alignItems="center" style="padding: 10px;">
								<Box>
									<Button
										outlined
										disabled={!state.changes}
										onClick={() => {
											window.location.reload();
										}}
									>
										Annuler les changements
									</Button>
								</Box>
								{tab !== tab_pwd && (
									<Box>
										<Button variant="contained" disabled={!updatedData.changes} onClick={handleSubmit}>
											{/* {state.next_uncomplete} */}
											{whichNext2()}
										</Button>
									</Box>
								)}
							</Box>
						)}
					</Paper>
				</Grid>

			</Grid>
		</div >
	);
}
